import { Event } from 'able-lib/'
import { NEW_EVENT_TEMPLATE } from 'src/lib/constants'

export interface EventStateInterface {
  events: Array<Event>;
  eventDraft: Event;
}

export default function (): EventStateInterface {
  return {
    events: [],
    eventDraft: JSON.parse(JSON.stringify(NEW_EVENT_TEMPLATE))
  }
}
